var ERROR_MESSAGES = {
  ARIA_LIVE_REGION_CONTEXT_MISSING: "AriaLiveRegionContext is not provided"
};

export { ERROR_MESSAGES };
